import { render } from "./HomeAboutUs.html?vue&type=template&id=c53274f0&scoped=true&ts=true&external"
import script from "./HomeAboutUs.ts?vue&type=script&lang=ts&external"
export * from "./HomeAboutUs.ts?vue&type=script&lang=ts&external"

import "./HomeAboutUs.scss?vue&type=style&index=0&id=c53274f0&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c53274f0"]])

export default __exports__